import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=3a1a7fcc&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1a7fcc')) {
      api.createRecord('3a1a7fcc', component.options)
    } else {
      api.reload('3a1a7fcc', component.options)
    }
    module.hot.accept("./ErrorBoundary.vue?vue&type=template&id=3a1a7fcc&", function () {
      api.rerender('3a1a7fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/ErrorBoundary.vue"
export default component.exports